import { render } from "./fb-type.vue?vue&type=template&id=52b91a3a&scoped=true"
import script from "./fb-type.vue?vue&type=script&lang=js"
export * from "./fb-type.vue?vue&type=script&lang=js"

import "./fb-type.vue?vue&type=style&index=0&id=52b91a3a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_Ejzw/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b91a3a"]])

export default __exports__